export default class Form {
  constructor() {
    this.init();
  }

  init() {
    const context = this;

    $('.field-group').each(function () {
      new Input($(this));
    });

    $('form').each(function () {
      let inputs = $(this).find('input[type=text],input[type=email],input[type=checkbox]');
      let form = $(this)[0];

      form.addEventListener('invalid', function (e) {
        e.preventDefault();
      }, true);

      form.addEventListener('submit', function (e) {
       
        let invalidFields = form.querySelectorAll(':invalid');
        if (invalidFields.length) {
          e.preventDefault();
          return false;
        }
      });

      let submitButton = $(this).find(':submit');
      submitButton.on('click', function () {
        $(form).addClass('was-validated');
        let invalidFields = form.querySelectorAll(':invalid');
        context.valid(inputs, invalidFields);
        if (invalidFields.length) {
          return false;
        }
      });
    });
  }

  valid(inputs, invalid) {
    let i = inputs.length;
    while (i--) {
      $(inputs[i]).removeClass('invalid');
    }

    i = invalid.length;
    while (i--) {
      $(invalid[i]).addClass('invalid');
    }

    return false;
  }
}

class Input {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    this.input = this.el.find('input');
    this.label = this.el.find('label');
    this.hasInitialFocus = false;

    if (/([^\s])/.test(this.input.val().trim())) {
      this.label.addClass('initial-focus');
      this.hasInitialFocus = true;
    }/*else if(this.input.attr('type').toLowerCase() === 'password'){
            this.label.addClass('initial-focus');
            this.hasInitialFocus = true;
            this.input.focus();
        }*/

    this.input.focus(() => {
      if (this.hasInitialFocus) {
        this.hasInitialFocus = false;
        this.label.removeClass('initial-focus');
      }
      this.label.addClass('focused');
    });
    this.input.blur(() => {
      if (!/([^\s])/.test(this.input.val().trim())) {
        this.label.removeClass('focused');
      }
    });
  }
}